import { FormInputProps } from '@/@types/form.types';
import { cn } from '@/lib/utils';
import { Controller } from 'react-hook-form';
import UncheckedIcon from '../icons/UncheckedIcon';
import CheckedIcon from '../icons/CheckedIcon';
import InformationCircle from '@/components/icons/InformationCircle';

type Props<T extends {}> = {
    text: string;
    onClick?: () => void;
} & FormInputProps<T>;

const ECheckboxInput = <T extends {}>({
    text,
    fieldName,
    control,
    className,
    containerClassName,
    disabled,
    onClick,
}: Props<T>) => {
    return (
        <Controller
            name={fieldName}
            control={control}
            render={({ field: { value, onChange }, fieldState, formState }) => {
                const handleClick = () => {
                    !(disabled || formState.disabled) && onChange(!value);
                    value && onClick?.();
                };

                return (
                    <>
                        <div
                            className={cn(
                                'flex items-center gap-1 select-none',
                                containerClassName,
                            )}
                        >
                            <div
                                className={cn('size-5 cursor-pointer ', className)}
                                onClick={handleClick}
                            >
                                {!value ? (
                                    <UncheckedIcon />
                                ) : (
                                    <CheckedIcon className="fill-primary-color stroke-primary-color" />
                                )}
                            </div>
                            <div className="w-0 flex-1 truncate">
                                <span className="text-sm cursor-pointer" onClick={handleClick}>
                                    {text}
                                </span>
                            </div>
                        </div>
                        {fieldState.invalid && (
                            <div className="flex items-center gap-1.5">
                                <InformationCircle className="size-4 stroke-error-1000" />
                                <span className="text-xs text-error-1000">
                                    {fieldState.error?.message}
                                </span>
                            </div>
                        )}
                    </>
                );
            }}
        />
    );
};

export default ECheckboxInput;
